(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["inknorth-artwork"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ink-artwork')) {
    class InkArtwork extends HTMLElement {
      connectedCallback() {
        this.file = this.querySelector('[data-art-file]');
        this.link = this.querySelector('[data-art-link]');
        this.error = this.querySelector('[data-art-error]');
        if (!this.file) return;
        this.maxBytes = Number(this.dataset.maxMb || 20) * 1024 * 1024;
        this.required = this.dataset.required === 'true';
        this.touched = false;
        const update = () => { this.touched = true; this.check(); };
        this.file.addEventListener('change', update);
        if (this.link) this.link.addEventListener('input', update);
        this.file.addEventListener('invalid', () => { this.touched = true; this.render(); });
        this.check();
      }

      check() {
        const file = this.file.files && this.file.files[0];
        const hasLink = !!(this.link && this.link.value.trim());
        let message = '';
        if (file && file.size > this.maxBytes) message = this.dataset.msgBig;
        else if (this.required && !file && !hasLink) message = this.dataset.msgMissing;
        this.file.setCustomValidity(message);
        this.render();
      }

      render() {
        const message = this.file.validationMessage && this.touched ? this.file.validationMessage : '';
        this.classList.toggle('is-invalid', !!message);
        if (!this.error) return;
        this.error.textContent = message;
        this.error.hidden = !message;
      }
    }
    customElements.define('ink-artwork', InkArtwork);
  }
  } catch(e) { console.error(e); }
})();

})();
